<template>
    <div class="divider"></div>
</template>
<script>
export default {
    name: 'divider'
}
</script>

<style scoped>
    .divider{
        height: .16rem;
        background: #f6f6f6;
    }
</style>

